
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classlink-login",
      function () {
        return require("private-next-pages/classlink-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classlink-login"])
      });
    }
  